import React, { createContext, useCallback, useState } from 'react'
import ErrorBanner from './ErrorBanner'

export const ErrorBannerContext = createContext({
	showError: () => {},
})

export const ErrorBannerProvider = ({ children }) => {
	const [message, setMessage] = useState('')

	const showError = useCallback(msg => {
		if (!msg) return

		setMessage(msg)

		setTimeout(() => {
			setMessage('')
		}, 3500)
	}, [])

	return (
		<ErrorBannerContext.Provider value={{ showError }}>
			{children}
			<ErrorBanner message={message} />
		</ErrorBannerContext.Provider>
	)
}
